<template>
    <CEESAR-Form :title="id==undefined ? 'New Site' : 'Site Modification '">
        <template slot="Content">
            <CEESAR-TextInputBox label="Code" v-model="entityCode" :required="true"/>
            <CEESAR-TextInputBox label="Label" v-model="entityLabel" :required="true"/>
        </template>    
        
        <template slot="Buttons">
            <CEESAR-Button label="Save" v-on:click="OnSave"/>
            <CEESAR-Button label="Cancel" v-on:click="OnCancel"/>
        </template>
    </CEESAR-Form>
</template>

<script>
export default {
    name: "SiteFile",
    props: {
        id: {default: undefined}
    },
    data(){
        return {
            entityCode: "",
            entityLabel: ""
        }
    },
    async mounted(){
        if(this.id != undefined)
        {
            let entity = await this.$ceesar.backend.GetModelByIdAsync("site", this.id);
            this.entityCode = entity.code;
            this.entityLabel = entity.label;
        }
    },
    methods:{
        OnCancel()
        {
            this.$router.go(-1);
        },
        async OnSave()
        {
            if(this.entityCode.trim() == "")
            {
                this.$ceesar.design.showToast("Code is mandatory.", "error");
                return;
            }

            if(this.entityLabel.trim() == "")
            {
                this.$ceesar.design.showToast("Label is mandatory.", "error");
                return;
            }

            if(this.id == undefined)
            {
                let entity = {
                    code: this.entityCode,
                    label: this.entityLabel 
                };
                let res = await this.$ceesar.backend.PostModelAsync("site", entity);
                if(res.code < 0)
                {
                    this.$ceesar.design.showToast(res.message, "error");
                    return;
                }
            }
            else
            {
                let entity = {
                    id: this.id,
                    code: this.entityCode,
                    label: this.entityLabel
                };
                let res = await this.$ceesar.backend.PutModelAsync("site", entity);
                if(res.code < 0)
                {
                    this.$ceesar.design.showToast(res.message, "error");
                    return;
                }
            }

            this.$router.go(-1);
        }
    }
}
</script>

<style lang="less">
</style>